import EarMarkDefaultPriceApi from "@/api/earmark/earMarkDefaultPriceApi";
export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        await EarMarkDefaultPriceApi.addOrUddate(form);
        dispatch('NOTIFY_MSG', 'earmark.notification.saveDefaultPrice', {root: true})
        return Promise.resolve();
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error)
      }
    },
    async fetchNewest({dispatch}, {articleGroup}) {
      try {
        const response = await EarMarkDefaultPriceApi.fetchNewest(articleGroup);
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error)
      }
    }
  }
}
